import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { withItems, withoutItems } from '../data/content';
import { CtaButton } from './CtaButton';
export function Comparison() {
  return <section className="w-full py-12 sm:py-16" aria-labelledby="comparativa-title" data-id="element-40" data-mp="1l6m984dhfxx7">
      <div className="mx-auto max-w-6xl px-6" data-id="element-41" data-mp="1pzp20aafr3cc">
        <div className="mx-auto max-w-2xl text-center" data-id="element-42" data-mp="1uxh5m1kg0dwd">
          <h2 id="comparativa-title" className="font-display text-3xl font-semibold leading-tight tracking-tight text-tinta sm:text-4xl" data-id="element-43" data-mp="1uwpbywaeoq8q">
            Improvisar tu cabeza o entrenarla de verdad
          </h2>
          <p className="mt-4 text-lg leading-snug text-tinta/65" data-id="element-44" data-mp="28wqai5377ll1">
            No es jugar mejor porque sí: es tener herramientas cuando aparece la
            presión.
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-45" data-mp="eipbnk7neyky">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45
        }} className="rounded-4xl border border-neutral-200/80 bg-neutral-50 p-8 sm:p-10" data-id="element-46" data-mp="ej7gv6cagn50">
            <h3 className="mb-8 flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.14em] text-neutral-500" data-id="element-47" data-mp="1d6b0qjjjsp16">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#F6DEDE] text-[#C56A6A]" data-id="element-48" data-mp="24zbc1mkqn0hc">
                <XIcon className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" data-id="element-49" data-mp="20xq50huvxgf2" />
              </span>
              Sin Mindfulness para Hockey
            </h3>
            <ul className="space-y-5" data-id="element-50" data-mp="1w0py64q7o9mw">
              {withoutItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-51" data-mp="1qzk15upiq07k">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#C56A6A]" strokeWidth={1.8} aria-hidden="true" data-id="element-52" data-mp="kkrn5vbh3dj1" />
                  <span className="text-[15px] leading-relaxed text-neutral-600" data-id="element-53" data-mp="h2vgi3arj1wo">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: 0.08
        }} className="rounded-4xl border border-salvia/50 bg-salvia/15 p-8 shadow-soft sm:p-10" data-id="element-54" data-mp="80cf7nmmkxcj">
            <h3 className="mb-8 flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.14em] text-bosque" data-id="element-55" data-mp="34436j3q5k9l">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-bosque text-white" data-id="element-56" data-mp="3phcgwoujw7t6">
                <CheckIcon className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" data-id="element-57" data-mp="3bhb3yb10h9xc" />
              </span>
              Con Mindfulness para Hockey
            </h3>
            <ul className="space-y-5" data-id="element-58" data-mp="2wvxbqizeymmt">
              {withItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-59" data-mp="2rwuc5e27d8m8">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-bosque" strokeWidth={1.8} aria-hidden="true" data-id="element-60" data-mp="36tbn446hcl89" />
                  <span className="text-[15px] leading-relaxed text-tinta/75" data-id="element-61" data-mp="3fu05fb2wp7qy">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-62" data-mp="3pkcn8vjc6mte">
          <p className="font-display text-xl leading-snug text-tinta sm:text-2xl" data-id="element-63" data-mp="3plw16fhisls0">
            El hockey no siempre lo gana quien mejor juega, sino quien mejor
            controla su mente bajo presión.
          </p>
          <CtaButton className="mt-8 w-full sm:w-auto" data-id="element-64" data-mp="3uiwcp5x52gqi" />
        </div>
      </div>
    </section>;
}